import { createContext } from "react";

//form error

//form info
export interface IFLEFormContext {
  mode: "Edit" | "Add" | "Info";
}
export const FLEFormContext = createContext<IFLEFormContext | null>(null);
